import React from 'react';

import Button from '@atlaskit/button';
import { login } from 'src/services/session';

const ConfigWithoutAccountsMapping = () => (
  <div data-cy="top-level-main-login">
    <br/>
      Please login to continue
    <br/>
    <br/>
    <Button appearance="primary" onClick={login}>Login with PagerDuty</Button>
  </div>
);

export default ConfigWithoutAccountsMapping;
